"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledWarning = void 0;
const material_1 = require("@mui/material");
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledWarning = (0, styled_components_1.default)(material_1.Paper) `
  padding: ${({ theme }) => theme.spacing(1, 4)};
  border-width: 0;
  border-top-width: 1px;
  cursor: pointer;

  &.MuiPaper-root {
    box-shadow: none;
  }

  .MuiList-root, .MuiTypography-root {
    cursor: pointer;
  }

  .MuiListItemIcon-root {
    min-width: unset;
  }

  .MuiListItemText-primary {
    color: ${({ theme }) => theme.palette.accent.main};
    font-size: 0.875rem;
  }

  .MuiListItemText-secondary {
    font-size: 0.75rem;
    color: ${({ theme }) => theme.palette.text.secondary};
  }
`;
